module.exports = __webpack_public_path__ + "static/media/orinocco24.68e42dbc.jpg";